export const ENV_VAR = {
  PRODUCCION: 'produccion',
  DESARROLLO: 'desarrollo',
  QA: 'qa'
};

export const PROJECT_ONLINE_URL = 'https://snoopconsulting.sharepoint.com/sites/pwa/project%20detail%20pages/schedule.aspx?projuid=';

export const URL_BASE =
  process.env.REACT_APP_ENV === ENV_VAR.PRODUCCION
    ? 'https://snoopgateway.azure-api.net/certificacion'
    : process.env.REACT_APP_ENV === ENV_VAR.QA
    ? 'https://snoopgateway.azure-api.net/certificacion-qa'
    : 'https://snoopgateway.azure-api.net/certificacion-dev';

export const PUBLIC_API_KEY =
  process.env.REACT_APP_ENV === ENV_VAR.PRODUCCION
    ? 'df6602a08fa64458855d03427f7c8faf'
    : process.env.REACT_APP_ENV === ENV_VAR.QA
    ? '128bef11cd9a473893893b3cdd0df5fa'
    : 'a54835f633f0442595d909da8830230e';

export const AUTH_HEADER = "Ocp-Apim-Subscription-Key";

export const concepto_tabla_proyecto = {
  CERTIFICADO: 'Certificado',
  TOGGL: 'Toggl',
  PLANIFICADO: 'Planificado',
};

export const USER_ROLES = {
  PM: "PM",
  CEO: "CEO",
  COO: "COO",
  DIRECTOR_SBU: "DIRECTOR_SBU",
  ADMIN: "ADMIN"
};
